<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">Add Content Type</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Content Types</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Create</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="! loading">
            <form @submit.prevent="submit" id="create_form">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label>Name</label>
                  <input type="text" placeholder="Name" v-model="type.name" name="name" class="form-control">
                </div>
                <div class="col-md-12">
                  <h4>Pricing</h4>
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Stars</th>
                        <th>No. Of Words</th>
                        <th>Price</th>
                        <th>Hours To Complete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="type.pricing.length == 0">
                        <td colspan="5">There is no data to display</td>
                      </tr>
                      <tr v-for="(quality, i) in type.pricing" :key="`quality-${i}`">
                        <td>{{ quality.name }}</td>
                        <td>{{ quality.stars }}</td>
                        <td>
                          <input type="number" placeholder="No. Of Words" class="form-control" v-model="type.pricing[i]['words']" :name="`pricing.${i}.words`">
                        </td>
                        <td>
                          <input type="number" placeholder="Price" class="form-control" v-model="type.pricing[i]['price']" :name="`pricing.${i}.price`">
                        </td>
                        <td>
                          <input type="number" placeholder="Hours To Complete" class="form-control" v-model="type.pricing[i]['hours']" :name="`pricing.${i}.hours`">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12 mb-3">
                  <button class="btn btn-primary">Save<i class="fa fa-save me-0 ms-2"></i></button>
                </div>
              </div>
            </form>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      loading: true,
      type: { pricing: [] }
    }
  },

  methods: {
    fetch() {
      this.loading = true

      this.$axios
        .get(`/api/v1/admin/types/${this.$route.params.id}`)
        .then((response) => {
          this.type = response.data.type;
          this.loading = false;
        });
    },

    submit() {
      let data = this.type
      data.form_id = 'create_form'

      this.$axios.put(`/api/v1/admin/types/${this.$route.params.id}`, data).then(response => { 
        this.$router.push({ name: 'admin.types.show', params: { id: response.data.id }})
      })
    }
  }
};
</script>